import { render } from "./TextSettings.vue?vue&type=template&id=cedef2d0&scoped=true"
import script from "./TextSettings.vue?vue&type=script&lang=js"
export * from "./TextSettings.vue?vue&type=script&lang=js"

import "./TextSettings.vue?vue&type=style&index=0&id=cedef2d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cedef2d0"]])

export default __exports__